// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__111eP","icon":"Footer_icon__2h8R9","details":"Footer_details__34JWO"};